module.exports = __webpack_public_path__ + "media/images/logo/logo_144x144-2d15c9c357f60f2dee7531e25c9801e0.png";